$(document).ready(function() {

    // breakpoint where swiper will be destroyed
    // and switches to a dual-column layout
    const breakpoint = window.matchMedia('(min-width:991px)');

    // keep track of swiper instances to destroy later
    let mySwiper;


    const breakpointChecker = function() {

        // if larger viewport and multi-row layout needed
        if (breakpoint.matches === true) {

            // clean up old instances and inline styles when available
            if (mySwiper !== undefined) mySwiper.destroy(true, true);

            // or/and do nothing
            return;

            // else if a small viewport and single column layout needed
        } else if (breakpoint.matches === false) {

            // fire small viewport version of swiper
            return enableSwiper();

        }

    };


    const enableSwiper = function() {

        mySwiper = new Swiper('.js-mobile-slider', {

            loop: true,
            slidesPerView: 1.2,
            pagination: {
                el: ".js-swiper-pagination",
                clickable: true
            },
            paginationClickable: true,
            // calculateHeight: true,
            autoHeight: false,
            breakpoints: {


                640: {
                    slidesPerView: 1.3,
                    spaceBetween: 8,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
                834: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                },

            },
        });

    };

    // keep an eye on viewport size changes
    breakpoint.addListener(breakpointChecker);

    // kickstart
    breakpointChecker();
})


var swiperIllustration = new Swiper('.js-tech-img-slider', {

    slidesPerView: 1,
    // pagination: {
    //     el: ".js-swiper-pagination",
    // },
    // paginationClickable: true,
    // calculateHeight: true,
    allowTouchMove: false,
    // breakpoints: {

    //     768: {
    //         slidesPerView: 2,
    //         spaceBetween: 20,
    //     },
    //     640: {
    //         slidesPerView: 1.2,
    //         spaceBetween: 8,
    //     },


    // },
});

$(".js-pointers li").click(function() {
    $(".js-pointers li").removeClass("active")
    $(this).addClass("active")
    swiperIllustration.slideTo($(this).index())
})